// React Component
import React, { useEffect, useState } from "react";
import Header from "../repeat/Header";
import Leftnavigation from "./Leftnavigation";
import Footer from "../repeat/Footer";
import "./style/generaldept.css";
import { Navigate } from "react-router-dom";

const Mechdepartment = () => {
  const [data, setData] = useState([]);
  const [files, setFiles] = useState([]);
  const [names, setNames] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [isEditing, setIsEditing] = useState(null);
  const [loading, setLoading] = useState(true);
const [username, setUsername] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");

    if (storedUsername) {
      setUsername(storedUsername);
    } else {
      setUsername(null);
    }
    setIsLoading(false);

    fetch("https://gptkpm.in/backend/admin/mech-dept-img.php")
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setData(data);
          setLoading(false);
          setNames(data.map((item) => item.name));
          setProfessions(data.map((item) => item.profession));
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  const handleFileChange = (event, id) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFiles((prev) => {
        const newFiles = [...prev];
        newFiles[id] = selectedFile;
        return newFiles;
      });
    }
  };

  const handleNameChange = (event, id) => {
    const updatedNames = [...names];
    updatedNames[id] = event.target.value;
    setNames(updatedNames);
  };

  const handleProfessionChange = (event, id) => {
    const updatedProfessions = [...professions];
    updatedProfessions[id] = event.target.value;
    setProfessions(updatedProfessions);
  };

  const handleSubmit = (event, id) => {
    event.preventDefault();

    if (!files[id] && !names[id] && !professions[id]) {
      alert("Please make at least one change.");
      return;
    }

    const formData = new FormData();
    formData.append("id", data[id].id);
    formData.append("name", names[id]);
    formData.append("profession", professions[id]);
    if (files[id]) {
      formData.append("image", files[id]);
    }

    fetch("https://gptkpm.in/backend/admin/mech-dept-img.php", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.success) {
          alert("Details updated successfully!");
          if (files[id]) {
            const updatedImage = URL.createObjectURL(files[id]);
            setData((prevData) => {
              const newData = [...prevData];
              newData[id].image = updatedImage;
              return newData;
            });
          }
          setIsEditing(null);
        } else {
          console.error("Error updating data:", responseData.error);
        }
      })
      .catch((error) => console.error("Error uploading data:", error));
  };
if (isLoading) {
    return <div>Loading...</div>;
  }

  // Redirect if session is not valid
  if (!username) {
    return <Navigate to="/Admin" />;
  }
  return (
    <div className="main-dept">
      <Header />
      <div style={{background:"#fff"}}>
      <Leftnavigation />
      </div>
      <div className="cme"> <h2>DEPARTMENT OF MECHANICAL ENGINEERING </h2></div>
      <div className="guidelines">
        <h3>Guidelines</h3>
        <ul>
          <h3>1.Photo Upload:</h3>
          <li>Ensure the uploaded image is high-resolution (minimum 1080x1080 pixels).</li>
          <li>Accept only professional photos (JPEG or PNG format).</li>
          <li>Restrict file size to a maximum of 5MB to optimize loading time.</li>
        </ul>
        <ul>
          <h3>2.Name Input:</h3>
          <li>The principal's name should be entered in title case (e.g., "Dr. John Smith").</li>
          <li>Validate the input to disallow numbers or special characters.</li>
        </ul>
        <ul>
          <h3>3.Experience:</h3>
          <li>Allow numerical input for years of experience.</li>
          <li>Include a multi-line input for brief descriptions of previous roles.</li>
        </ul>
        <ul>
          <h3>4.Designation:</h3>
          <li>Input should automatically capitalize each word (e.g., "Principal").
          </li>
          <li>Allow a maximum of 50 characters.
          </li>
        </ul>
      </div>
      <div className="box2">
        <div id="right">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="general-dept-form">
              {data.map((item, index) => (
                <div
                  key={item.id}
                  className={`boxx ${isEditing === index ? "editing" : ""}`}
                >
                  <div
                    className="imagee"
                    style={{ backgroundImage: `url(${item.image})` }}
                  ></div>
                  <div className="data">
                    <h2>NAME: {item.name}</h2>
                    <p>PROFESSION: {item.profession}</p>
                  </div>
                  <button onClick={() => setIsEditing(index)}>Edit</button>

                  {isEditing === index && (
                    <form onSubmit={(e) => handleSubmit(e, index)} className="form-1">
                      <h2>Edit Details</h2>
                      <input
                        type="text"
                        onChange={(e) => handleNameChange(e, index)}
                        placeholder="Update Name"
                      />
                      <input
                        type="text"
                        onChange={(e) => handleProfessionChange(e, index)}
                        placeholder="Update Profession"
                      />
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, index)}
                      />
                      <button type="submit">Save</button>
                    </form>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default Mechdepartment;